// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page-container {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: linear-gradient(160deg, #020c1b 0%, #0a1f44 40%, #0d3b6e 80%, #0e4f8c 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.particles { position: fixed; inset: 0; pointer-events: none; z-index: 0; }
.particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 193, 7, 0.12);
  animation: float linear infinite;
}
@keyframes float {
  0%   { transform: translateY(110vh) scale(0); opacity: 0; }
  10%  { opacity: 1; }
  90%  { opacity: 0.5; }
  100% { transform: translateY(-10vh) scale(1.2); opacity: 0; }
}

@media (max-width: 768px) {
  .error-wrapper { padding: 40px 16px 80px; }
  .error-code { letter-spacing: -4px; }
  .error-icon { width: 48px; height: 48px; }
  .http-badge { font-size: 0.7rem; padding: 5px 14px; }
  .btn-back { padding: 12px 26px; font-size: 0.88rem; }
  .timer-warning { font-size: 0.76rem; padding: 8px 14px; }
}
@media (max-width: 480px) {
  .error-code { font-size: 28vw; letter-spacing: -3px; }
  .error-title { font-size: 1.3rem; }
  .error-subtitle { font-size: 0.88rem; }
}

.error-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px 120px;
  position: relative;
  z-index: 5;
  text-align: center;
  width: 100%;
}

.error-code {
  font-size: clamp(100px, 22vw, 220px);
  font-weight: 900;
  line-height: 1;
  background: linear-gradient(135deg, #FFC107 0%, #FF8F00 50%, #FFD54F 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 0 40px rgba(255, 193, 7, 0.4));
  letter-spacing: -8px;
  animation: pulse-glow 3s ease-in-out infinite;
  margin: 10px 0;
}
@keyframes pulse-glow {
  0%, 100% { filter: drop-shadow(0 0 30px rgba(255,193,7,0.35)); }
  50%       { filter: drop-shadow(0 0 60px rgba(255,193,7,0.7)); }
}

.error-icon {
  color: #FFC107;
  margin: 8px 0 20px;
  animation: icon-spin 4s ease-in-out infinite;
}
@keyframes icon-spin {
  0%   { transform: rotate(0deg); }
  25%  { transform: rotate(-15deg); }
  75%  { transform: rotate(15deg); }
  100% { transform: rotate(0deg); }
}

.divider {
  width: 80px; height: 3px;
  background: linear-gradient(90deg, transparent, #FFC107, transparent);
  border-radius: 2px;
  margin: 20px auto;
}

.error-title {
  font-size: clamp(1.4rem, 4vw, 2.2rem);
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 20px rgba(0,0,0,0.5);
  margin: 0;
}
.error-subtitle {
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  color: rgba(255,255,255,0.65);
  max-width: 480px;
  margin: 12px auto 0;
  line-height: 1.7;
  font-weight: 300;
}

.http-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.35);
  border-radius: 50px;
  padding: 6px 18px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #FFD54F;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.error-actions {
  display: flex;
  gap: 16px;
  margin-top: 40px;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 36px;
  background: linear-gradient(135deg, #E65100, #FF8F00);
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 8px 30px rgba(255, 143, 0, 0.4);
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}
.btn-back:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 40px rgba(255,143,0,0.6);
  color: #fff;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 36px;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}
.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.5);
}

.timer-warning {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,193,7,0.08);
  border: 1px solid rgba(255,193,7,0.2);
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 0.82rem;
  color: rgba(255,255,255,0.5);
  margin-top: 20px;
}
.timer-warning svg { color: #FFC107; }

.waves-container {
  width: 100%;
  overflow: hidden;
  line-height: 0;
  position: relative;
  z-index: 1;
  margin-top: auto;
}
.waves-container svg { display: block; width: 200%; }
.wave1 { animation: wave-move 8s linear infinite; }
.wave2 { animation: wave-move 12s linear infinite reverse; opacity: 0.6; }
.wave3 { animation: wave-move 6s linear infinite; opacity: 0.4; }
@keyframes wave-move {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.site-footer {
  width: 100%; text-align: center;
  padding: 18px 20px;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.35);
  position: relative; z-index: 10; line-height: 1.8;
}
.site-footer a { color: rgba(255,255,255,0.45); text-decoration: none; }
.site-footer a:hover { color: #FFC107; }
`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA,aAAa,eAAe,EAAE,QAAQ,EAAE,oBAAoB,EAAE,UAAU,EAAE;AAC1E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,OAAO,qCAAqC,EAAE,UAAU,EAAE;EAC1D,OAAO,UAAU,EAAE;EACnB,OAAO,YAAY,EAAE;EACrB,OAAO,uCAAuC,EAAE,UAAU,EAAE;AAC9D;;AAEA;EACE,iBAAiB,uBAAuB,EAAE;EAC1C,cAAc,oBAAoB,EAAE;EACpC,cAAc,WAAW,EAAE,YAAY,EAAE;EACzC,cAAc,iBAAiB,EAAE,iBAAiB,EAAE;EACpD,YAAY,kBAAkB,EAAE,kBAAkB,EAAE;EACpD,iBAAiB,kBAAkB,EAAE,iBAAiB,EAAE;AAC1D;AACA;EACE,cAAc,eAAe,EAAE,oBAAoB,EAAE;EACrD,eAAe,iBAAiB,EAAE;EAClC,kBAAkB,kBAAkB,EAAE;AACxC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oDAAoD;EACpD,oBAAoB;EACpB,6CAA6C;EAC7C,cAAc;AAChB;AACA;EACE,WAAW,kDAAkD,EAAE;EAC/D,YAAY,iDAAiD,EAAE;AACjE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;EAClC,OAAO,wBAAwB,EAAE;EACjC,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE,WAAW,EAAE,WAAW;EACxB,qEAAqE;EACrE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,SAAS;AACX;AACA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,qBAAqB,cAAc,EAAE;;AAErC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA,uBAAuB,cAAc,EAAE,WAAW,EAAE;AACpD,SAAS,uCAAuC,EAAE;AAClD,SAAS,gDAAgD,EAAE,YAAY,EAAE;AACzE,SAAS,uCAAuC,EAAE,YAAY,EAAE;AAChE;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW,EAAE,kBAAkB;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB,EAAE,WAAW,EAAE,gBAAgB;AACnD;AACA,iBAAiB,6BAA6B,EAAE,qBAAqB,EAAE;AACvE,uBAAuB,cAAc,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;900&display=swap');\n\n.error-page-container {\n  font-family: 'Inter', sans-serif;\n  min-height: 100vh;\n  background: linear-gradient(160deg, #020c1b 0%, #0a1f44 40%, #0d3b6e 80%, #0e4f8c 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n  color: #fff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n}\n\n.particles { position: fixed; inset: 0; pointer-events: none; z-index: 0; }\n.particle {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 193, 7, 0.12);\n  animation: float linear infinite;\n}\n@keyframes float {\n  0%   { transform: translateY(110vh) scale(0); opacity: 0; }\n  10%  { opacity: 1; }\n  90%  { opacity: 0.5; }\n  100% { transform: translateY(-10vh) scale(1.2); opacity: 0; }\n}\n\n@media (max-width: 768px) {\n  .error-wrapper { padding: 40px 16px 80px; }\n  .error-code { letter-spacing: -4px; }\n  .error-icon { width: 48px; height: 48px; }\n  .http-badge { font-size: 0.7rem; padding: 5px 14px; }\n  .btn-back { padding: 12px 26px; font-size: 0.88rem; }\n  .timer-warning { font-size: 0.76rem; padding: 8px 14px; }\n}\n@media (max-width: 480px) {\n  .error-code { font-size: 28vw; letter-spacing: -3px; }\n  .error-title { font-size: 1.3rem; }\n  .error-subtitle { font-size: 0.88rem; }\n}\n\n.error-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px 120px;\n  position: relative;\n  z-index: 5;\n  text-align: center;\n  width: 100%;\n}\n\n.error-code {\n  font-size: clamp(100px, 22vw, 220px);\n  font-weight: 900;\n  line-height: 1;\n  background: linear-gradient(135deg, #FFC107 0%, #FF8F00 50%, #FFD54F 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 0 40px rgba(255, 193, 7, 0.4));\n  letter-spacing: -8px;\n  animation: pulse-glow 3s ease-in-out infinite;\n  margin: 10px 0;\n}\n@keyframes pulse-glow {\n  0%, 100% { filter: drop-shadow(0 0 30px rgba(255,193,7,0.35)); }\n  50%       { filter: drop-shadow(0 0 60px rgba(255,193,7,0.7)); }\n}\n\n.error-icon {\n  color: #FFC107;\n  margin: 8px 0 20px;\n  animation: icon-spin 4s ease-in-out infinite;\n}\n@keyframes icon-spin {\n  0%   { transform: rotate(0deg); }\n  25%  { transform: rotate(-15deg); }\n  75%  { transform: rotate(15deg); }\n  100% { transform: rotate(0deg); }\n}\n\n.divider {\n  width: 80px; height: 3px;\n  background: linear-gradient(90deg, transparent, #FFC107, transparent);\n  border-radius: 2px;\n  margin: 20px auto;\n}\n\n.error-title {\n  font-size: clamp(1.4rem, 4vw, 2.2rem);\n  font-weight: 700;\n  color: #fff;\n  text-shadow: 0 2px 20px rgba(0,0,0,0.5);\n  margin: 0;\n}\n.error-subtitle {\n  font-size: clamp(0.9rem, 2.5vw, 1.1rem);\n  color: rgba(255,255,255,0.65);\n  max-width: 480px;\n  margin: 12px auto 0;\n  line-height: 1.7;\n  font-weight: 300;\n}\n\n.http-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.35);\n  border-radius: 50px;\n  padding: 6px 18px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #FFD54F;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.error-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 40px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 36px;\n  background: linear-gradient(135deg, #E65100, #FF8F00);\n  color: #fff;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  text-decoration: none;\n  box-shadow: 0 8px 30px rgba(255, 143, 0, 0.4);\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n}\n.btn-back:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 40px rgba(255,143,0,0.6);\n  color: #fff;\n}\n\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 36px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  font-family: 'Inter', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n}\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.timer-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255,193,7,0.08);\n  border: 1px solid rgba(255,193,7,0.2);\n  border-radius: 12px;\n  padding: 10px 20px;\n  font-size: 0.82rem;\n  color: rgba(255,255,255,0.5);\n  margin-top: 20px;\n}\n.timer-warning svg { color: #FFC107; }\n\n.waves-container {\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n  position: relative;\n  z-index: 1;\n  margin-top: auto;\n}\n.waves-container svg { display: block; width: 200%; }\n.wave1 { animation: wave-move 8s linear infinite; }\n.wave2 { animation: wave-move 12s linear infinite reverse; opacity: 0.6; }\n.wave3 { animation: wave-move 6s linear infinite; opacity: 0.4; }\n@keyframes wave-move {\n  0%   { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n.site-footer {\n  width: 100%; text-align: center;\n  padding: 18px 20px;\n  font-size: 0.75rem;\n  color: rgba(255,255,255,0.35);\n  position: relative; z-index: 10; line-height: 1.8;\n}\n.site-footer a { color: rgba(255,255,255,0.45); text-decoration: none; }\n.site-footer a:hover { color: #FFC107; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
